import { PRESET } from "../lib/lighting-presets";

export default function GlobalLights() {
  const p = PRESET;

  return (
    <>
      <hemisphereLight groundColor={p.hemisphere.groundColor} intensity={p.hemisphere.intensity} />
      <directionalLight
        position={p.dirLight1.position}
        intensity={p.dirLight1.intensity}
        castShadow
        shadow-mapSize-width={p.dirLight1.shadowSize}
        shadow-mapSize-height={p.dirLight1.shadowSize}
        shadow-camera-near={0.5}
        shadow-camera-far={60}
        shadow-camera-left={-25}
        shadow-camera-right={25}
        shadow-camera-top={25}
        shadow-camera-bottom={-25}
        shadow-bias={-0.001}
      />
      {/* Secondary fill light: no shadow. One shadow-casting directional light is
          enough; a second shadow map doubles per-light shadow cost for little gain. */}
      {p.dirLight2 && (
        <directionalLight
          position={p.dirLight2.position}
          intensity={p.dirLight2.intensity}
          color={p.dirLight2.color}
        />
      )}
      {/* Point lights are short-range fill only — NOT shadow casters. A point-light
          shadow is a 6-face cube map; 5 of them = 30 extra full-scene render passes
          on the first frame (the dominant cause of the long initial load / stutter). */}
      {p.pointLights.map((pl, i) => (
        <pointLight
          key={i}
          position={pl.position}
          intensity={pl.intensity}
          distance={pl.distance}
          color={pl.color}
        />
      ))}
    </>
  );
}
